import { Link } from 'react-router-dom';

export default function MobileHeader() {
  return (
    <header className="fixed top-0 left-0 right-0 h-16 bg-white/80 backdrop-blur-md border-b border-gray-200 z-50 md:hidden flex items-center justify-between px-4 gap-2 min-w-0">
      <Link to="/" className="text-xl font-bold bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent shrink-0">
        BPI
      </Link>
      <div className="flex min-w-0 items-center gap-2">
        <div className="w-8 h-8 shrink-0 rounded-full bg-blue-50 flex items-center justify-center">
          <span className="text-blue-600 text-xs font-bold">IBC</span>
        </div>
      </div>
    </header>
  );
}
